var map = {
	"./agreement.svg": "9467",
	"./dashboard.svg": "f782",
	"./health.svg": "1010",
	"./jichu.svg": "2f7f",
	"./scaleAdmin.svg": "380d",
	"./scaleTypeAdmin.svg": "dedb",
	"./sign.svg": "2496",
	"./xitong.svg": "23a3",
	"./yewu.svg": "c0e1",
	"./yunying.svg": "1b26"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";